import { isNil } from 'lodash';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useViewTemplateLayout } from '@shared/scenes/workflows/hooks';
import { EntityFormLayout } from './EntityFormLayout';
import { EntityFormProps } from './EntityFormProps';

export function EntityForm(props: EntityFormProps) {
  const { workflowTemplateId, viewTemplateId } = props;
  const { layout, loading } = useViewTemplateLayout(workflowTemplateId, viewTemplateId);

  if (loading || isNil(workflowTemplateId) || isNil(viewTemplateId)) {
    return <MBLoadingIndicator fill />;
  }

  return <EntityFormLayout {...props} layout={layout} />;
}
